import React from 'react';
import { PiUserCircleLight } from 'react-icons/pi';
import { Text } from 'src/modules/shared/components/atoms/text';
import { Panel } from 'src/modules/shared/components/molecules/panel';
import { PanelHeader } from 'src/modules/shared/components/molecules/panel/panel-header';
import { SectionHeading } from 'src/modules/shared/components/molecules/section-heading/section-heading';
import { EnterKeyModeSetting } from 'src/modules/shared/components/molecules/writing/enter-key-mode-setting';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

export const PreferencesSettingsPage: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="flex flex-col h-full">
      <Panel className="h-full flex flex-col">
        <PanelHeader className="px-4 py-3 border-b">
          <div className="flex items-center gap-4">
            <PiUserCircleLight className="w-8 h-8" />
            <div className="space-y-1">
              <Text as="h2" size="h2" weight="medium">
                {t('settings.preferences.title')}
              </Text>
              <Text size="small" color="secondary">
                {t('settings.preferences.description')}
              </Text>
            </div>
          </div>
        </PanelHeader>

        <div className="flex-1 overflow-auto p-6 space-y-6">
          <section className="max-w-3xl space-y-4">
            <SectionHeading
              title={t('settings.preferences.sections.messaging.title')}
            />

            <EnterKeyModeSetting />
          </section>
        </div>
      </Panel>
    </div>
  );
};
